import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { makeStyles } from '@material-ui/core/styles';
import { getAddress, formatPhoneNumber } from '../../constants/constants';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Button from '@material-ui/core/Button';
import LockIcon from '@material-ui/icons/Lock';
import PersonIcon from '@material-ui/icons/Person';
import BusinessIcon from '@material-ui/icons/Business';
import Title from '../common/custom-components/customTitleHeader';
import AgentUpdatePasswordForm from './agent-update-modal';
import InfoMessageBar from '../common/info-message/info-message';
import Link from '@material-ui/core/Link';
import { Link as LinkRouter } from 'react-router-dom';
import _ from 'lodash';
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#F7F8F9',
    paddingBottom: 40,
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  title: {
    flexGrow: 1,
  },
  icon: {
    color: '#0073a8',
  },
}));

export function AgentProfileForm(props) {
  const classes = useStyles();

  console.log('AgentProfileForm', props);

  return (
    <React.Fragment>
      <Title text="Profile" />
      <div className={classes.root}>
        {props.message && (
          <InfoMessageBar
            variant="success"
            icColor="successIc"
            message={props.message}
          />
        )}
        {props.data && (
          <div>
            <AppBar position="static" color="inherit">
              <Toolbar className={classes.title}>
                <IconButton
                  edge="start"
                  className={classes.menuButton}
                  color="primary"
                  aria-label="menu"
                >
                  <PersonIcon />
                  {'    '}
                  <Typography variant="body1" className={classes.title}>
                    &nbsp;&nbsp; Name
                  </Typography>
                </IconButton>

                <Typography
                  variant="body1"
                  className={classes.title}
                ></Typography>

                <Typography variant="body1" className={classes.title}>
                  {props.data.firstName} &nbsp;{props.data.lastName}
                </Typography>
              </Toolbar>
            </AppBar>
            <br />
            <AppBar position="static" color="inherit">
              <Toolbar className={classes.title}>
                <IconButton
                  edge="start"
                  className={classes.menuButton}
                  color="primary"
                  aria-label="menu"
                >
                  <AccountCircle />
                  {'    '}
                  <Typography variant="body1" className={classes.title}>
                    &nbsp;&nbsp;UserID
                  </Typography>
                </IconButton>

                <Typography
                  variant="body1"
                  className={classes.title}
                ></Typography>

                <Typography variant="body1" className={classes.title}>
                  {props.data.emailAddress}
                </Typography>
              </Toolbar>
            </AppBar>
            <br />
            <AppBar position="static" color="inherit">
              <Toolbar className={classes.title}>
                <IconButton
                  edge="start"
                  className={classes.menuButton}
                  color="primary"
                  aria-label="menu"
                >
                  <LockIcon />{' '}
                  <Typography variant="body1" className={classes.title}>
                    &nbsp;&nbsp;Password
                  </Typography>
                </IconButton>

                <Typography
                  variant="body1"
                  className={classes.title}
                ></Typography>

                <Typography variant="body1" className={classes.title}>
                  ********
                </Typography>
                <div>
                  <Button
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    color="primary"
                    onClick={props.handleModalOpen}
                    value={'password'}
                  >
                    Edit
                  </Button>
                  <AgentUpdatePasswordForm
                    open={props.modalOpen}
                    close={props.handleModalClose}
                    cancel={props.handleModalClose}
                    type={props.type}
                    errors={props.errors}
                  />
                </div>
              </Toolbar>
            </AppBar>
            <br />
            <AppBar
              position="static"
              color="inherit"
              style={{ height: '185px' }}
            >
              <Toolbar className={classes.title}>
                <IconButton
                  edge="start"
                  className={classes.menuButton}
                  color="primary"
                  aria-label="menu"
                >
                  <BusinessIcon />{' '}
                  <Typography variant="body1" className={classes.title}>
                    &nbsp;&nbsp;Company
                  </Typography>
                </IconButton>

                <Typography
                  variant="body1"
                  className={classes.title}
                ></Typography>

                <Typography variant="body1" className={classes.title}>
                  {props.data.companyName}
                  <br />
                  {getAddress(props.data.street, props.data.streetline2)}
                  <br />
                  {props.data.city}, {props.data.state} {props.data.zipCode}{' '}
                  <br />
                  {formatPhoneNumber(props.data.phoneNumber)} <br />
                  {props.data.companyWebSite !== undefined &&
                    !_.isEmpty(props.data.companyWebSite) && (
                      <div className="website-link">
                        <a
                          rel="noopener noreferrer"
                          href={props.data.companyWebSite}
                          target="_blank"
                        >
                          {props.data.companyWebSite}
                        </a>
                      </div>
                    )}
                </Typography>
                <div>
                  <Button
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    color="primary"
                    onClick={props.handleModalOpen}
                    value={'company'}
                  >
                    Edit
                  </Button>
                  <AgentUpdatePasswordForm
                    open={props.modalOpen}
                    close={props.handleModalClose}
                    cancel={props.handleModalClose}
                    type={props.type}
                    errors={props.errors}
                    initialValues={{
                      companyName: props.data.companyName,
                      Str: props.data.street,
                      str2: props.data.streetline2,
                      city: props.data.city,
                      state: props.data.state,
                      zip: props.data.zipCode,
                      phonenumber: props.data.phoneNumber,
                      url: props.data.companyWebSite,
                      // insurComp: insurComp,
                    }}
                  />
                </div>
              </Toolbar>
            </AppBar>
            <br />
          </div>
        )}
      </div>
      <div className="link-pad-profile">
        <Link
          component={LinkRouter}
          to="/home"
          variant="body2"
          style={{
            fontSize: 20,
            fontFamily: 'Arial',
            textAlign: 'center',
            align: 'center',
          }}
        >
          Go Back
        </Link>
      </div>
    </React.Fragment>
  );
}

AgentProfileForm.propTypes = {
  errors: PropTypes.object,
  message: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func,
  handleModalOpen: PropTypes.func,
  invalid: PropTypes.func,
  submitting: PropTypes.func,
  pristine: PropTypes.func,
  modalOpen: PropTypes.bool,
  type: PropTypes.string,
  passwordError: PropTypes.string,
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    companyName: PropTypes.string,
    street: PropTypes.string,
    streetline2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.number,
    emailAddress: PropTypes.string,
    phoneNumber: PropTypes.string,
    companyWebSite: PropTypes.string,
  }),
};

export default reduxForm({
  form: 'updatePasswordForm',
  // a unique identifier for this form
})(AgentProfileForm);
